import { useContext } from 'react';
import { ScannerContext } from '../contexts/scanner-context';

export const useScanner = () => useContext(ScannerContext);
